import { render, staticRenderFns } from "./zhuyuan-detail.vue?vue&type=template&id=b43bd406&scoped=true"
import script from "./zhuyuan-detail.vue?vue&type=script&lang=ts"
export * from "./zhuyuan-detail.vue?vue&type=script&lang=ts"
import style0 from "./zhuyuan-detail.vue?vue&type=style&index=0&id=b43bd406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43bd406",
  null
  
)

export default component.exports